import { render } from "./BaseLabel.vue?vue&type=template&id=1577fa98&scoped=true"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"

import "./BaseLabel.vue?vue&type=style&index=0&id=1577fa98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1577fa98"]])

export default __exports__